import axios from 'axios'
import ElementUI from "element-ui";

export const baseURL = process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:8081';

const request = axios.create({
    baseURL: baseURL,
    timeout: 30000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';

    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
    if(user) {
        config.headers['token'] = user.token;  // 设置请求头
    }

    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        if (response.config.responseType === 'blob') {
            return res
        }
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        if (res.code === '401') {
            ElementUI.Message({
                message: res.msg,
                type: 'error'
            })
        }
        return res;
    },
    error => {
        const config = error.config || {};
        const url = config.url || '';
        
        // Skip default error message for blob downloads to let component handle specific errors
        if (config.responseType === 'blob') {
            return Promise.reject(error);
        }

        if (url.indexOf('/ai/chat') === -1) {
            ElementUI.Message({
                message: error.message || '请求失败',
                type: 'error'
            })
        }
        return Promise.reject(error)
    }
)


export default request

